import list from './list'
import item from './item'
import form from './form'
import estimate from './estimate'

export default {
	namespaced: true,
	modules: {
		list,
		item,
		form,
		estimate,
	},
}
